import { render, staticRenderFns } from "./ItemTags.vue?vue&type=template&id=55439836"
import script from "./ItemTags.vue?vue&type=script&lang=ts"
export * from "./ItemTags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports